import { createReducer, on } from "@ngrx/store";
import * as CalendarActions from "./calendar.actions";
import type { CalendarState } from "./calendar.models";

export const initialState: CalendarState = {
  events: [],
  range: null,
  loading: false,
  error: null,
};

function upsertEvent(events: CalendarState['events'], next: CalendarState['events'][number]) {
  const index = events.findIndex((event) => event.id === next.id);
  if (index < 0) {
    return [next, ...events].sort((a, b) => a.start_at.localeCompare(b.start_at));
  }

  const updated = [...events];
  updated[index] = next;
  return updated.sort((a, b) => a.start_at.localeCompare(b.start_at));
}

export const calendarReducer = createReducer(
  initialState,

  on(CalendarActions.CalendarEventsFetchRequest, (state, { start, end }) => ({
    ...state,
    range: { start, end },
    loading: true,
    error: null,
  })),

  on(CalendarActions.CalendarEventsFetchSuccess, (state, { start, end, events }) => ({
    ...state,
    range: { start, end },
    events,
    loading: false,
    error: null,
  })),

  on(CalendarActions.CalendarEventsFetchFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CalendarActions.CalendarEventCreateSuccess, (state, { event }) => ({
    ...state,
    events: upsertEvent(state.events, event),
  })),

  on(CalendarActions.CalendarEventUpdateSuccess, (state, { event }) => ({
    ...state,
    events: upsertEvent(state.events, event),
  })),

  on(CalendarActions.CalendarEventDeleteSuccess, (state, { eventId }) => ({
    ...state,
    events: state.events.filter((event) => event.id !== eventId),
  })),
);
